import { render, staticRenderFns } from "./Speedometer.vue?vue&type=template&id=38025c3f&"
import script from "./Speedometer.vue?vue&type=script&lang=js&"
export * from "./Speedometer.vue?vue&type=script&lang=js&"
import style0 from "./Speedometer.vue?vue&type=style&index=0&id=38025c3f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports